import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Marquee } from "@/components/site/Marquee";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Toaster } from "sonner";

const META = {
  "/": {
    title: "Fede & Fitness Italia | Life Coach Cristiani | Metodo Tempio Vivo",
    desc: "Elio e Chiara, Life Coach Cristiani e fondatori di Fede & Fitness Italia. Scopri il Metodo Tempio Vivo, Uomo Biblico, Donna Virtuosa, Academy e App.",
  },
  "/tempio": { title: "Metodo Tempio Vivo | Life Coaching Cristiano" },
  "/uomo": { title: "Uomo Biblico | Percorso Uomo Cristiano" },
  "/donna": { title: "Donna Virtuosa | Percorso Donna Cristiana" },
  "/app": { title: "App Tempio Vivo | Sfida del Deserto" },
};

export const Layout = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const meta = META[pathname] || META["/"];
    document.title = meta.title;
    if (meta.desc) {
      const el = document.querySelector('meta[name="description"]');
      if (el) el.setAttribute("content", meta.desc);
    }
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        setTimeout(() => target.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <div className="bg-[#0B0B0B] min-h-screen">
      <Marquee />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
};
